import { computed } from 'vue'

import { Result, ResultId } from '@collector/sportsapi-client-legacy'

import { useParticipants } from './useParticipants'

type ResultsMap = Record<ResultId, Result>

const toResultsMap = (results: Result[] | undefined): ResultsMap =>
  Object.fromEntries((results ?? []).map((r) => [r.id, r])) as ResultsMap

export const useParticipantResultsMaps = () => {
  const { homeParticipant, awayParticipant } = useParticipants()

  return {
    homeParticipantResultsMap: computed(() =>
      toResultsMap(homeParticipant.value?.results),
    ),
    awayParticipantResultsMap: computed(() =>
      toResultsMap(awayParticipant.value?.results),
    ),
  }
}
